/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { BodyGenerateTaskRubricTaskAnalysis } from './bodyGenerateTaskRubricTaskAnalysis';
import type { BodyGenerateTaskRubricDraftTask } from './bodyGenerateTaskRubricDraftTask';

export interface BodyGenerateTaskRubric {
  task_analysis?: BodyGenerateTaskRubricTaskAnalysis;
  draft_task?: BodyGenerateTaskRubricDraftTask;
}
